import React from "react";
import SearchFormTimeSlots from "./search_form_time_slots";

// 「別条件で検索する」モーダルの中身（人気順・開催順・新着・時間帯フィルタ）。
// 人気順は search_form.jsx 側の画面上ショートカットからも同じsortEventFuncで呼べるが、
// モーダル内からも選べるようここにもボタンを持たせている。
const SearchFormSort = ({
  sortEventKeys,
  sortEventFunc,
  eventCondition = "",
  timeSlot,
  onChangeTimeSlot,
}) => {

  return (
    <div className="search-event__narrow-btn d-flex flex-column">
      <p className="mb-1" style={{ fontSize: "0.7rem", color: "#999999" }}>並び順</p>
      <div className="d-flex flex-wrap mb-3">
        <button
          className={`btn btn-sm rounded-pill ${
            eventCondition == ""
              ? "btn-secondary"
              : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.poplular}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          人気順
        </button>
        <button
          className={`text-fz-14px btn btn-sm rounded-pill ${
            eventCondition == sortEventKeys.recently
              ? "btn-secondary"
              : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.recently}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          開催順
        </button>
        <button
          className={`btn btn-sm rounded-pill ${
            eventCondition == sortEventKeys.new
              ? "btn-secondary"
              : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem" }}
          value={sortEventKeys.new}
          onClick={(e) => sortEventFunc(e.target.value)}
        >
          新着
        </button>
      </div>
      <div className="mb-2">
        <p className="mb-1" style={{ fontSize: "0.7rem", color: "#999999" }}>時間帯</p>
        <div className="d-flex flex-wrap align-items-center">
          <SearchFormTimeSlots
            timeSlot={timeSlot}
            onChangeTimeSlot={onChangeTimeSlot}
          />
        </div>
        <p className="mt-2 mb-0" style={{ fontSize: "0.65rem", color: "#aaa", paddingLeft: "8px" }}>
          朝 4:00〜10:59 / 昼 11:00〜16:59 / 夜 17:00〜3:59
        </p>
      </div>
    </div>
  );
};

export default SearchFormSort;